module.exports = flarum.core.compat['components/AdminNav'];